import { useExamsList } from '../exams-list/useExamsList';

export const useDashboard = () => {
	const { examsList } = useExamsList({ fetchAllExams: true });

	return {
		examsList,
	};
};
